import { render } from "./module.vue?vue&type=template&id=70f19260"
import script from "./module.vue?vue&type=script&lang=js"
export * from "./module.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"dev/modules/theme/item-merch/module.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70f19260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70f19260', __exports__)) {
    api.reload('70f19260', __exports__)
  }
  
  module.hot.accept("./module.vue?vue&type=template&id=70f19260", () => {
    api.rerender('70f19260', render)
  })

}


export default __exports__